var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",attrs:{"to":_vm.link,"role":"button"}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"control-icon control-icon--left",attrs:{"icon":("" + _vm.icon)}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }